/**
 * author: Soumya Shreyas
 */
import React, { useState, useEffect, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./FormHome.scss";
import { Container } from "react-bootstrap";
import FormCreate from "../FormCreate/FormCreate";
import RecentlyCreated from "../RecentlyCreated/RecentlyCreated";
import FormLists from "../FormLists/FormLists";
import Utils from "../../core/utilities/Utils";
import { FormContext } from "../../App";
import { LS_ACCESS_TOKEN_KEY, LS_RETURN_PARAMS_KEY, LS_FORM_PERMISSIONS_KEY } from "../../core/constants/common";

const FormHome = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const stringParam = searchParams.get("q");
  const { formObj, setFormObj} = useContext(FormContext);

  useEffect(() => {
    if (stringParam) {
      decodeParam(stringParam);
    }
  }, []);
  const decodeParam = async(decodeString) => {
    localStorage.clear();
    var decodedData = Utils.decodeBase64(decodeString);
    let paramObj = JSON.parse(decodedData);
    localStorage.setItem(LS_ACCESS_TOKEN_KEY, paramObj.at);
    if (paramObj.params) {
      localStorage.setItem(LS_RETURN_PARAMS_KEY, JSON.stringify(paramObj.params));
    }
    const obj = {
      formType: paramObj.ft,
      id: paramObj.id,
      key: paramObj.k ? paramObj.k : null,
      Permissions:paramObj.hasPermission ? paramObj.hasPermission : null,
    };
   
    if (paramObj.a === "EDIT") {
      setFormObj(obj);
      localStorage.setItem(LS_FORM_PERMISSIONS_KEY, JSON.stringify(obj));
      navigate({
        pathname: `/form_builder/form_edit/${paramObj.eId}`,
      });
    } else if (paramObj.a === "SUBMIT" || paramObj.a === "SHARE" || paramObj.a === "REVIEW") {
      var urlObj = "";
      if (paramObj.sId) {
        urlObj = {
          id: paramObj.eId,
          key: paramObj.k ? paramObj.k : null,
          sId: paramObj.sId,
        };
      } else {
        urlObj = {
          id: paramObj.eId,
          key: paramObj.k ? paramObj.k : null,
        };
      }
      var encodeUrl = Utils.encodeBase64(JSON.stringify(urlObj));
      var decodedD = Utils.decodeBase64(encodeUrl);
      setFormObj(decodedD);
      if(paramObj.a === "REVIEW") {
        navigate({
          pathname: `/form_builder/review/${paramObj.k}`,
        });
      } else {
        navigate({
          pathname: `/form_builder/form_submit/${encodeUrl}`,
        });
      }
    }
  };
  return (
    <div className="FormLists">
      <div className="pt-2">
        <Container>
            <FormCreate />
            <RecentlyCreated />
            <FormLists />
        </Container>
      </div>
    </div>
  );
};

export default FormHome;
